import { apiSlice } from "../../app/api/apiSlice";

export const itineraryApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // 📁 Fetch all trip itinerary records (Admin Workspace)
    getItineraries: builder.query({
      query: () => "/itineraries",
      providesTags: ["Itinerary"],
    }),

    // 🚀 Create a brand new itinerary content package
    createItinerary: builder.mutation({
      query: (body) => ({
        url: "/itineraries",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Itinerary"],
    }),

    // ✏️ Overwrite trip parameters, stops, or checkbox ticks
    updateItinerary: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/itineraries/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Itinerary"],
    }),

    // 🗑️ Permanently purge an item from the planner deck
    deleteItinerary: builder.mutation({
      query: (id) => ({
        url: `/itineraries/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Itinerary"],
    }),
  }),
});

export const {
  useGetItinerariesQuery,
  useCreateItineraryMutation,
  useUpdateItineraryMutation,
  useDeleteItineraryMutation,
} = itineraryApiSlice;
